import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, Icon } from '../../campaign-os';

/**
 * Regularization has two ways in. "Through the vendor" is the existing rectification-link
 * flow; "Self-regularization" verifies what is already on record with no email at all. The
 * switch sits at the top of both screens so the operator always sees the other option.
 */
const MODES = [
  {
    key: 'vendor',
    label: 'Through the vendor',
    to: '/campaigning-tool/regularization',
    icon: 'forward_to_inbox',
    blurb: 'Email the vendor a rectification link; they re-enter their details and the form verifies them.',
  },
  {
    key: 'self',
    label: 'Self-regularization',
    to: '/campaigning-tool/regularization/self',
    icon: 'fact_check',
    blurb: 'Verify what is already on record straight against the registries. No email to the vendor.',
  },
];

export function RegularizationModeTabs({ mode }) {
  const navigate = useNavigate();
  const active = MODES.find((m) => m.key === mode) || MODES[0];
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <Tabs
        items={MODES.map(({ key, label }) => ({ key, label }))}
        value={active.key}
        onChange={(key) => {
          const next = MODES.find((m) => m.key === key);
          if (next && next.key !== active.key) navigate(next.to);
        }}
      />
      <p className="flex min-w-0 items-center gap-1.5 text-[12px] leading-[18px] text-cos-ink-secondary">
        <Icon name={active.icon} className="shrink-0 text-[16px] text-cos-teal-deep" />
        <span>{active.blurb}</span>
      </p>
    </div>
  );
}

export default RegularizationModeTabs;
